import React, { useState } from "react";
import { Transition } from "@headlessui/react"; // For smooth animations

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const toggleFAQ = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  const faqs = [
    {
      title: "Who Requires a Visa for New Zealand?",
      content: (
        <>
          <p>
            You need a visa to travel to New Zealand for purposes such as
            tourism, study, or work. However, citizens from countries with a
            visa waiver agreement only need to apply for an{" "}
            <strong>Electronic Travel Authority (ETA)</strong> prior to their
            visit.
          </p>
        </>
      ),
    },
    {
      title: "What Documents Are Required for a Study Visa?",
      content: (
        <>
          <p>To apply for a New Zealand Study Visa, you will need:</p>
          <ul className="mt-2 list-inside list-disc">
            <li>Completed application form (online or paper).</li>
            <li>Language proficiency proof (e.g., IELTS).</li>
            <li>Health certificate (including chest X-ray for tuberculosis).</li>
            <li>Character certificate (no criminal history).</li>
            <li>Proof of tuition fee payment or financial support.</li>
            <li>Letter of acceptance from an approved education provider.</li>
            <li>Travel insurance covering your stay.</li>
            <li>Accommodation details.</li>
            <li>Relevant practical experience certificates (if applicable).</li>
            <li>Parent/guardian consent if under 18 years old.</li>
          </ul>
        </>
      ),
    },
    {
      title: "What Are the Necessary Means of Accommodation While Studying in New Zealand?",
      content: (
        <>
          <p>
            Accommodation options include dormitories, shared housing, or
            independent rentals in cities like Auckland, Wellington and
            Christchurch. Costs range between 250 and 600 NZD per week
            depending on location and type of housing.
          </p>
        </>
      ),
    },
    {
      title: "What Are the Means of Travel and Transport?",
      content: (
        <>
          <p>New Zealand offers excellent transport options:</p>
          <ul className="mt-2 list-inside list-disc">
            <li>Buses for city and regional travel.</li>
            <li>Trains connecting major locations.</li>
            <li>Ferries between the North and South Islands.</li>
            <li>
              Driving, provided you hold an authorized international or New
              Zealand driver’s license.
            </li>
          </ul>
        </>
      ),
    },
    {
      title: "How Can One Work and Study in New Zealand?",
      content: (
        <>
          <p>
            Students aged 17 and above can work part-time for up to 20 hours per
            week during the semester. Look for opportunities on job portals and
            ensure your CV highlights your skills.
          </p>
        </>
      ),
    },
    {
      title: "Who Can Be Granted a Permanent Residence Permit in New Zealand?",
      content: (
        <>
          <p>Permanent residence permits are granted to individuals who:</p>
          <ul className="mt-2 list-inside list-disc">
            <li>Have been employed in New Zealand for more than two years.</li>
            <li>Hold a valid business or entrepreneur visa.</li>
            <li>Meet health and character standards.</li>
            <li>Have ties to New Zealand through family or work.</li>
          </ul>
        </>
      ),
    },
    {
      title: "Top Universities in New Zealand",
      content: (
        <>
          <p>Some of the top universities in New Zealand include:</p>
          <ul className="mt-2 list-inside list-disc">
            <li>AUT University</li>
            <li>The University of Auckland</li>
            <li>Lincoln University</li>
            <li>Victoria University of Wellington</li>
            <li>Massey University</li>
            <li>The University of Waikato</li>
            <li>The University of Canterbury</li>
            <li>The University of Otago</li>
          </ul>
        </>
      ),
    },
    {
      title: "What is the Best Time to Travel to New Zealand?",
      content: (
        <>
          <p>
            The best time to visit New Zealand is from{" "}
            <strong>October to April</strong>. This period offers pleasant
            weather and plenty of opportunities for outdoor activities.
          </p>
        </>
      ),
    },
    {
      title: "What is the Weather Like in New Zealand?",
      content: (
        <>
          <p>
            New Zealand has a temperate climate with mild temperatures, moderate
            rainfall and plenty of sunshine. The warmest months are January and
            February, while July is the coldest.
          </p>
        </>
      ),
    },
    
  ];

  return (
    <>
      <div className="flex w-full flex-col items-center justify-center py-20">
        {isOpen && (
          <div className="mb-6 w-3/4 items-center  text-black justify-center rounded-md bg-gray-100 p-4 text-lg shadow-md">
            <p>
              <br />
              - Located in the heart of the water hemisphere, surrounded by
              stunning natural beauty.
              <br />
              - Known for its multicultural society, blending Maori traditions
              with European influences.
              <br />
              - Offers a high standard of living, excellent work-life balance,
              and top-notch education.
              <br />
              - Transparent immigration policies and a welcoming environment for
              immigrants.
              <br />
              - Temperate climate with opportunities for year-round outdoor
              activities.
              <br />
              - Thriving economy with abundant career prospects and organized
              public services.
              <br />
              Embark on your journey to New Zealand and experience a perfect
              blend of nature and modernity with Visa World!
            </p>
          </div>
        )}
        <button
          onClick={toggleAnswer}
          className="flex md:w-1/2 w-2/2 items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
        >
          Why Choose New Zealand?
          <svg
            className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${
              isOpen ? "rotate-180" : ""
            }`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 5v14M5 12l7 7 7-7"></path>
          </svg>
        </button>
      </div>

      <div className="mx-auto max-w-5xl rounded-lg bg-white p-6">
        <h2 className="mb-4 text-center text-4xl font-semibold text-[#011473]">
          FAQ's
        </h2>
      </div>

      <div className="mx-auto max-w-5xl p-6">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="mb-4 overflow-hidden rounded-lg border shadow-sm"
          >
            <button
              className={`flex w-full  items-center justify-between px-4 py-3 text-left font-semibold ${
                openIndex === index ? "bg-blue-600 text-white" : "bg-gray-100"
              }`}
              onClick={() => toggleFAQ(index)}
            >
              {faq.title}
              <span
                className={`transform transition-transform ${
                  openIndex === index ? "rotate-180" : "rotate-0"
                }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="h-5 w-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
            </button>
            <Transition
              show={openIndex === index}
              enter="transition-all duration-200 ease-out"
              enterFrom="max-h-0 opacity-0"
              enterTo="max-h-96 opacity-100"
              leave="transition-all duration-200 ease-in"
              leaveFrom="max-h-96 opacity-100"
              leaveTo="max-h-0 opacity-0"
            >
              <div className="bg-white px-4 py-3 text-gray-700">
                {faq.content}
              </div>
            </Transition>
          </div>
        ))}
      </div>
    </>
  );
};

export default FAQ;
